// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	type HolidaySidePeekPack,
	registerHolidaySidePeekPack,
} from '@app/features/holiday/components/HolidaySidePeekResolvers';
import DisappointedCat from '@app/features/holiday/packs/baseline/assets/peeking/side/disappointed-cat.svg?react';

export const BASELINE_SIDE_PEEK_HEIGHT_REM = 16.8;
export const BASELINE_SIDE_PEEK_MAX_WIDTH_PERCENT = 30;
export const BASELINE_SIDE_PEEK_MAX_HEIGHT_PERCENT = 50;

export const BASELINE_SIDE_PEEK_PACK: HolidaySidePeekPack = {
	id: 'baseline',
	seasonal: false,
	heightRem: BASELINE_SIDE_PEEK_HEIGHT_REM,
	maxWidthPercent: BASELINE_SIDE_PEEK_MAX_WIDTH_PERCENT,
	maxHeightPercent: BASELINE_SIDE_PEEK_MAX_HEIGHT_PERCENT,
	chance: () => 1,
	isEnabled: () => true,
	peekers: [
		{
			id: 'disappointed-cat',
			Svg: DisappointedCat,
		},
	],
};

let registered = false;
let unsubscribe: (() => void) | null = null;

function dispose(): void {
	unsubscribe?.();
	unsubscribe = null;
	registered = false;
}

export function registerBaselineSidePeekers(): void {
	if (registered) return;
	registered = true;
	unsubscribe = registerHolidaySidePeekPack(BASELINE_SIDE_PEEK_PACK);
}

if (import.meta.hot) {
	import.meta.hot.dispose(() => {
		dispose();
	});
}
